<template>
    <div>
        <form class="my-4">
            <div class="passwordUpdateMsg"></div>

            <div class="row">
                <div class="col-12 col-md-6 order-md-2">
                    <div class="form-group">
                        <input type="password" name="oldpassword" id="oldpassword" class="form-control"
                            placeholder="Old password" v-model="oldpassword" v-validate="'required'"
                            data-vv-as="old password"
                        >
                        <span class="text-danger">{{ errors.first('oldpassword') }}</span>
                    </div>

                    <div class="form-group">
                        <input type="password" name="newpassword" id="newpassword" class="form-control" ref="newpassword"
                            placeholder="New password" v-model="newpassword" v-validate="'required|min:8|max:20'"
                            data-vv-as="new password"
                        >
                        <span class="text-danger">{{ errors.first('newpassword') }}</span>
                    </div>

                    <div class="form-group">
                        <input type="password" name="confirmpassword" id="confirmpassword" class="form-control" 
                            placeholder="Confirm password" v-model="confirmpassword" v-validate="'required|confirmed:newpassword'"
                            data-vv-as="confirm password"
                        >
                        <span class="text-danger">{{ errors.first('confirmpassword') }}</span>
                    </div>

                    <div class="form-group" @click.prevent="updatePassword($event)">
                        <button class="btn btn-success px-5">
                            Update password
                        </button>
                    </div>
                </div>
                <div class="col-12 col-md-6 order-md-2">
                    <div class="card bg-light border ml-md-4">
                        <div class="card-body">
                        
                            <p class="mb-2">Password requirements</p>

                            <p class="small text-muted mb-2">
                                To create a new password, you have to meet all of the following requirements:
                            </p>

                            <ul class="small text-muted pl-4 mb-0">
                                <li>Minimum 8 characters</li>
                                <li>Maximum 20 characters</li>
                            </ul>

                        </div>
                    </div>

                </div>

            </div>
        </form>
    </div>
</template>

<script>
    import axios from 'axios';
    export default {
        name: 'Password',
        data() {
            return {
                newpassword: '',
                confirmpassword: '',
                oldpassword: ''
            }
        },
        methods: {
            //update password
            updatePassword(e) {
                $('.s-v-e').remove();
                let btnn = e.currentTarget;

                this.$validator.validateAll().then((result) => {
                    if (result) {

                        btnn.setAttribute('disabled', '');
                        btnn.classList.add('is-loading');
                        btnn.classList.add('is-loading-sm');

                        let params = new URLSearchParams();
                        params.append('oldpassword', this.oldpassword);
                        params.append('newpassword', this.newpassword);
                        params.append('confirmpassword', this.confirmpassword);
                        params.append('mask', this.$store.state.userData.adminid);

                        axios.post(APIURL + 'admin/password/update', params)
                        .then((response) => {
                            
                            btnn.removeAttribute('disabled');
                            btnn.classList.remove('is-loading');
                            btnn.classList.remove('is-loading-sm');

                            let res = response.data;

                            if (res.status == 200) {
                                this.newpassword = '',
                                this.confirmpassword = '',
                                this.oldpassword = ''
                                this.$validator.reset();
                                this.$swal('Success', res.msg, 'success');
                            }
                            else {
                                if (res.status == 403) {
                                    $.each(res.errors, function(k, v) {
                                        $('.s-v-e').after(v);
                                    })
                                }
                                else {
                                    let msg = document.querySelector('.passwordUpdateMsg');
                                    msg.innerHTML = `<p class="text-danger s-v-e">${res.msg}</p>`;
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        })
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/backend/profile/Password.vue